export const DATA_LAYER_EVENTS = {
    FUNNEL_STEP: 'funnel_step',
    PAYMENT_GATEWAY_UPDATED: 'payment_gateway_updated',
    PURCHASE: 'purchase',
    PURCHASE_FAILED: 'purchase_failed',
    LEAD_SUBMIT: 'lead_submit',
    LEAD_FAILED: 'lead_failed',
    MOBILE_POPUP_SHOWN: 'mobile_popup_shown',
    OTP_CODE_REQUESTED: 'otp_code_requested',
    OTP_VERIFIED: 'otp_verified',
    OTHER_BILL_CLICK: 'other_bill_click',
    SUPPORT_INTERACTION: 'support_interaction',
    PAGEVIEW: 'pageview'
} as const;

export const OTP_SUB_FUNNEL = {
    name: 'otp_verification',
    steps: {
        popupShown: {
            sub_step_number: 1,
            sub_step_name: 'popup_shown',
            event: DATA_LAYER_EVENTS.MOBILE_POPUP_SHOWN
        },
        codeRequested: {
            sub_step_number: 2,
            sub_step_name: 'code_requested',
            event: DATA_LAYER_EVENTS.OTP_CODE_REQUESTED
        },
        verified: {
            sub_step_number: 3,
            sub_step_name: 'verified',
            event: DATA_LAYER_EVENTS.OTP_VERIFIED
        }
    }
} as const;
